import { render } from "./Metric.vue?vue&type=template&id=4a57f0c2"
import script from "./Metric.vue?vue&type=script&lang=js"
export * from "./Metric.vue?vue&type=script&lang=js"

import "./Metric.vue?vue&type=style&index=0&id=4a57f0c2&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__